import { createColorPaletteVariables, setVariablesStyle } from './create-styles';
import {
    accentNegativePalleteDay,
    accentNegativePalleteNight,
    accentPositivePalleteDay,
    accentPositivePalleteNight,
    accentWarningPalleteDay,
    accentWarningPalleteNight,
    mainPalleteDay,
    mainPalleteNight,
    neutralPalleteDay,
    neutralPalleteNight,
    primaryPalleteDay,
    primaryPalleteNight
} from "@pano-project/assets/styles/variables/color_schema";

export const setBrandColors = (theme, colorsSet = {}) => {
    const isDarkTheme = theme === 'dark';
    const variablesSelector = `:root`;
    const mainPalette = isDarkTheme ? mainPalleteNight : mainPalleteDay;
    const primaryPalette = isDarkTheme ? primaryPalleteNight : primaryPalleteDay;
    const neutralPalette = isDarkTheme ? neutralPalleteNight : neutralPalleteDay;
    const accentNegativePalette = isDarkTheme ? accentNegativePalleteNight : accentNegativePalleteDay;
    const accentPositivePalette = isDarkTheme ? accentPositivePalleteNight : accentPositivePalleteDay;
    const accentWarningPalette = isDarkTheme ? accentWarningPalleteNight : accentWarningPalleteDay;
    const colorsSchema = {
        main: isDarkTheme ? '#121212' : '#FFFFFF',
        primary: isDarkTheme ? '#0F758A' : '#0F768A',
        neutral: isDarkTheme ? '#8D97AA' : '#8A94A8',
        accent_negative: isDarkTheme ? '#F5475B' : '#F53D53',
        accent_positive: isDarkTheme ? '#41C8B3' : '#3FC0AC',
        accent_warning: isDarkTheme ? '#FFA64D' : '#FFA64D',
        ...colorsSet
    }
    const main = createColorPaletteVariables(['main_0', colorsSchema.main], mainPalette);
    setVariablesStyle(main, variablesSelector, 'mainPalette');
    const primary = createColorPaletteVariables(['primary_active', colorsSchema.primary], primaryPalette);
    setVariablesStyle(primary, variablesSelector, 'primaryPalette');
    const neutral = createColorPaletteVariables(['neutral_active', colorsSchema.neutral], neutralPalette);
    setVariablesStyle(neutral, variablesSelector, 'neutralPalette');
    const accent_negative = createColorPaletteVariables(['accent_negative', colorsSchema.accent_negative], accentNegativePalette);
    setVariablesStyle(accent_negative, variablesSelector, 'accentNegativePalette');
    const accent_positive = createColorPaletteVariables(['accent_positive', colorsSchema.accent_positive], accentPositivePalette);
    setVariablesStyle(accent_positive, variablesSelector, 'accentPositivePalette');
    const accent_warning = createColorPaletteVariables(['accent_warning', colorsSchema.accent_warning], accentWarningPalette);
    setVariablesStyle(accent_warning, variablesSelector, 'accentWarningPalette');

    return `${main} ${primary} ${neutral} ${accent_negative} ${accent_positive} ${accent_warning}`;
}
